import { CustomerTypeEnum } from '@ztechapps/common.contract'

export const CustomerType = {
  Basic: {
    value: CustomerTypeEnum.Basic,
    label: CustomerTypeEnum.Basic,
  },
  Reseller: {
    value: CustomerTypeEnum.Reseller,
    label: CustomerTypeEnum.Reseller,
  },
}
